import { __read, __values } from "tslib";
import classNames from "classnames";
import { callBoth } from "./call-both";
import { mergeStyle } from "./merge-style";
export function attachProps(rawProps, newProps) {
    var e_1, _a;
    var props = {};
    try {
        for (var _b = __values(Object.entries(newProps)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), propName = _d[0], propValue = _d[1];
            if (typeof propValue === "function") {
                // 子节点之前已经有处理函数，则同时调用
                if (rawProps[propName]) {
                    props[propName] = callBoth(propValue, rawProps[propName]);
                }
                else {
                    props[propName] = propValue;
                }
            }
            else if (propName === "className") {
                props[propName] = classNames(rawProps.className, propValue);
            }
            else if (propName === "style") {
                props[propName] = mergeStyle(rawProps.style, propValue);
            }
            else {
                props[propName] = propValue;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return props;
}
//# sourceMappingURL=attach-props.js.map